import ApiService from "@/utils/request";
export const whApi = {
    // 仓库基本信息
    getWarehouse: () => ApiService.get("/wms/stat/warehouse/total?warehouseCode=01"),
    // 获取货架信息
    getInfoByShelfCode: (shelfCode) => ApiService.get(`/wms/stat/shelf/used?shelfCode=${shelfCode}`),
    // 获取货位资产列表
    getInfoBySlotCode: (slotCode) => ApiService.get(`/wms/stat/shelf/row/total?shelfRowCode=${slotCode}`),
    // 返回不需要载具的货位编码
    getSlotHasVehicle: () => ApiService.get(`/wh/shelf/getSlotHasVehicle`),
};
